module.exports = __webpack_public_path__ + "img/search_by_nuclus.74454aab.gif";